import React from "react";

const ClientsSVG = ({ activeSvgColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 30 36"
      fill="none"
    >
      <path
        d="M28.1096 15.5891H17.1507C17.1507 10.3288 20.9498 9.7443 22.8493 9.89042C27.4082 9.89042 28.2557 13.5434 28.1096 15.5891Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.5205H13.3973"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5342 18.6575L16.4658 21.726V28.3014L10.7671 34V21.726L2 12.9589V8.57535H16.0274"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="22.8493"
        cy="5.06849"
        r="3.06849"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="23"
    //   height="18"
    //   viewBox="0 0 23 18"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M5.40405 7.30013C5.40405 8.10013 5.60405 8.90013 5.90405 9.60013H1.80405C1.20405 9.60013 0.60405 9.30013 0.30405 8.80013C0.00405282 8.20013 -0.0959472 7.60013 0.10405 7.10013C0.50405 6.1001 1.30405 5.3001 2.20405 4.8001C1.80405 4.3001 1.50405 3.6001 1.50405 2.9001C1.50405 1.4001 2.80405 0.100098 4.30405 0.100098C5.90405 0.100098 7.10405 1.4001 7.10405 2.9001C7.10405 3.0001 7.10405 3.2001 7.10405 3.3001C6.10405 4.3001 5.40405 5.7001 5.40405 7.30013Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M21.7043 8.7C21.4043 9.2 20.8043 9.5 20.2043 9.5H16.1043C16.4043 8.8 16.6043 8 16.6043 7.2C16.6043 5.6 16.0043 4.2 14.9043 3.2C14.9043 3.1 14.9043 2.9 14.9043 2.8C14.9043 1.2 16.2043 0 17.7043 0C19.2043 0 20.5043 1.3 20.5043 2.8C20.5043 3.5 20.2043 4.2 19.8043 4.7C20.7043 5.3 21.4043 6.1 21.9043 7.1C22.1043 7.6 22.0043 8.2 21.7043 8.7Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M13.4037 10.5001C14.4037 9.80015 15.1037 8.60015 15.1037 7.20015C15.1037 5.0002 13.3037 3.2002 11.1037 3.2002C8.90373 3.2002 7.00373 5.1002 7.00373 7.30015C7.00373 8.60015 7.70373 9.80015 8.70373 10.6001C6.90373 11.2001 5.50373 12.6002 4.70373 14.4002C4.40373 15.1002 4.50373 15.9001 4.90373 16.6001C5.40373 17.3001 6.10373 17.7001 6.90373 17.7001H15.1037C15.9037 17.7001 16.7037 17.3001 17.1037 16.6001C17.5037 15.9001 17.6037 15.1002 17.3037 14.4002C16.6037 12.5002 15.1037 11.2001 13.4037 10.5001Z"
    //     fill={activeSvgColor}
    //   />
    // </svg>
  );
};

export default ClientsSVG;
